module.exports = __webpack_public_path__ + "img/store.c8ca6a1c.png";